import { Image } from '@/shared/ui/image/Image';
import { useWishlist } from '../model/hooks';
import { Box } from '@/shared/ui/box/Box';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { Condition } from '@/shared/ui/condition/condition';
// import { useToast } from '@/shared/providers/toast-provider/ToastProvider';
import { ShowOnMobile, ShowOnDesktop } from '@/shared/ui/responsive';
import { WishlistButtonMobile } from './styles';
import { BodyTextRegularSecondary } from '@/shared/ui/typography';
import { useScopedI18n } from '@locales/client';
import { getWishlistSet } from '@/entities/game/model/helpers';

const WishlistToggle = ({ gameId, title }) => {
  const { trigger } = useWishlist();
  const { user, mutateWishlist } = useUser();
  // const { showToast } = useToast();
  const loc = useScopedI18n('common.game.dockbar');
  const isInWishlist = user.isAuth && getWishlistSet(user.wishlist).has(gameId);

  const handleToggle = async (e) => {
    e.stopPropagation();
    try {
      await trigger({
        gameId,
        val: !isInWishlist,
      });
      mutateWishlist();
      // showToast({
      //   type: 'success',
      //   message: !isInWishlist
      //     ? `${title} added to favorites`
      //     : `${title} removed from favorites`,
      // });
    } catch (error) {}
  };

  return (
    <Condition match={user.isAuth}>
      <ShowOnMobile>
        <Box
          $display={'flex'}
          $justifyContent={'flex-end'}
          $alignItems="center"
          $gap={12}
        >
          <Condition match={!isInWishlist}>
            <BodyTextRegularSecondary color={'#AFAFAF'}>
              {loc('favorite')}
            </BodyTextRegularSecondary>
          </Condition>
          <Condition match={isInWishlist}>
            <BodyTextRegularSecondary color={'#AFAFAF'}>
              {loc('unfavorite')}
            </BodyTextRegularSecondary>
          </Condition>
          <Box>
            <WishlistButtonMobile
              $isSelected={isInWishlist}
              variant="gray"
              style={{
                padding: '0',
                borderRadius: '100px',
                height: '40px',
                width: '40px',
              }}
              icon={
                <Image
                  width={20}
                  height={20}
                  src={
                    isInWishlist
                      ? '/images/icons/heart-filled.svg'
                      : '/images/icons/heart-unfilled.svg'
                  }
                />
              }
              onClick={handleToggle}
            ></WishlistButtonMobile>
          </Box>
        </Box>
      </ShowOnMobile>
      <ShowOnDesktop>
        <Box onClick={handleToggle}>
          <Image
            width={20}
            height={20}
            src={
              isInWishlist
                ? '/images/icons/heart-filled.svg'
                : '/images/icons/heart-unfilled.svg'
            }
          />
        </Box>
      </ShowOnDesktop>
    </Condition>
  );
};

export { WishlistToggle };
